<template>
    <div :ref="'container'" >
        <vs-popup :active.sync="open" :title="$t('Priority')">
            <vs-select autocomplete v-model="data">
                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:1, name:1}, {id:2, name:2}, {id:3, name:3}, {id:4, name:4}, {id:5, name:5}]" />
            </vs-select>
        </vs-popup>

    </div>

</template>
<script>
    import Vue from "vue";

    export default Vue.extend({
        data () {
            return {
                data: 0,
                open: false
            }
        },
        methods: {
            getValue() {
                return this.data;
            },
        },
        watch:{
            data: function () {
                if(this.open){
                    this.open = false;
                    Vue.nextTick(() => {
                        this.params.api.stopEditing();
                    });
                }
            },
            open: function () {
                if(!this.open){
                    Vue.nextTick(() => {
                        this.params.api.stopEditing();
                    });
                }
            }
        },
        created() {
            this.data = this.params.value
        },
        mounted() {
            Vue.nextTick(() => {
                this.open = true;
                this.$refs.container.focus();

            });
        }
    });

</script>
